import { render, staticRenderFns } from "./CabinetSelector.vue?vue&type=template&id=c0270dd4"
import script from "./CabinetSelector.vue?vue&type=script&lang=ts"
export * from "./CabinetSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports